import { render, staticRenderFns } from "./terms-and-conditions.vue?vue&type=template&id=957eae62&scoped=true"
import script from "./terms-and-conditions.vue?vue&type=script&lang=js"
export * from "./terms-and-conditions.vue?vue&type=script&lang=js"
import style0 from "./terms-and-conditions.vue?vue&type=style&index=0&id=957eae62&prod&lang=scss"
import style1 from "./terms-and-conditions.vue?vue&type=style&index=1&id=957eae62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957eae62",
  null
  
)

export default component.exports